"use client";

import { c as _c } from "react/compiler-runtime";
import type { SortDirection } from "@/entities/ISort";
import { ApiCommunityMembersSortOption } from "@/generated/models/ApiCommunityMembersSortOption";
import { useState } from "react";
import CommunityMembersTableHeaderSortableContent from "./CommunityMembersTableHeaderSortableContent";
export default function CommunityMembersTableHeader(t0) {
  const $ = _c(69);
  const {
    activeSort,
    sortDirection,
    isLoading,
    onSort
  } = t0;
  const [hoverOption, setHoverOption] = useState(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <th scope="col" className="tw-whitespace-nowrap tw-px-4 tw-py-3 tw-text-left tw-text-sm tw-font-medium tw-text-iron-400 sm:tw-px-6 sm:tw-text-md">Rank</th>;
    t2 = <th scope="col" className="tw-whitespace-nowrap tw-py-3 tw-pr-4 tw-text-left tw-text-sm tw-font-medium tw-text-iron-400 sm:tw-text-md">Profile</th>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onSort) {
    t3 = () => onSort(ApiCommunityMembersSortOption.Level);
    $[2] = onSort;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setHoverOption(ApiCommunityMembersSortOption.Level);
    t5 = () => setHoverOption(null);
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== activeSort || $[7] !== hoverOption || $[8] !== isLoading || $[9] !== sortDirection) {
    t6 = <CommunityMembersTableHeaderSortableContent sort={ApiCommunityMembersSortOption.Level} activeSort={activeSort} sortDirection={sortDirection} isLoading={isLoading} hoveringOption={hoverOption} />;
    $[6] = activeSort;
    $[7] = hoverOption;
    $[8] = isLoading;
    $[9] = sortDirection;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <th scope="col" className="tw-group tw-cursor-pointer tw-whitespace-nowrap tw-px-4 tw-py-3 tw-text-center tw-text-sm tw-font-medium tw-text-iron-400 sm:tw-px-6 sm:tw-text-md" onClick={t3} onMouseEnter={t4} onMouseLeave={t5}>{t6}</th>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== onSort) {
    t8 = () => onSort(ApiCommunityMembersSortOption.Tdh);
    $[14] = onSort;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t10;
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setHoverOption(ApiCommunityMembersSortOption.Tdh);
    t10 = () => setHoverOption(null);
    $[16] = t10;
    $[17] = t9;
  } else {
    t10 = $[16];
    t9 = $[17];
  }
  let t11;
  if ($[18] !== activeSort || $[19] !== hoverOption || $[20] !== isLoading || $[21] !== sortDirection) {
    t11 = <CommunityMembersTableHeaderSortableContent sort={ApiCommunityMembersSortOption.Tdh} activeSort={activeSort} sortDirection={sortDirection} isLoading={isLoading} hoveringOption={hoverOption} />;
    $[18] = activeSort;
    $[19] = hoverOption;
    $[20] = isLoading;
    $[21] = sortDirection;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t8) {
    t12 = <th scope="col" className="tw-group tw-cursor-pointer tw-whitespace-nowrap tw-px-4 tw-py-3 tw-text-right tw-text-sm tw-font-medium tw-text-iron-400 sm:tw-px-6 sm:tw-text-md" onClick={t8} onMouseEnter={t9} onMouseLeave={t10}>{t11}</th>;
    $[23] = t11;
    $[24] = t8;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== onSort) {
    t13 = () => onSort(ApiCommunityMembersSortOption.Xtdh);
    $[26] = onSort;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  let t15;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setHoverOption(ApiCommunityMembersSortOption.Xtdh);
    t15 = () => setHoverOption(null);
    $[28] = t14;
    $[29] = t15;
  } else {
    t14 = $[28];
    t15 = $[29];
  }
  let t16;
  if ($[30] !== activeSort || $[31] !== hoverOption || $[32] !== isLoading || $[33] !== sortDirection) {
    t16 = <CommunityMembersTableHeaderSortableContent sort={ApiCommunityMembersSortOption.Xtdh} activeSort={activeSort} sortDirection={sortDirection} isLoading={isLoading} hoveringOption={hoverOption} />;
    $[30] = activeSort;
    $[31] = hoverOption;
    $[32] = isLoading;
    $[33] = sortDirection;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t13 || $[36] !== t16) {
    t17 = <th scope="col" className="tw-group tw-cursor-pointer tw-whitespace-nowrap tw-px-4 tw-py-3 tw-text-right tw-text-sm tw-font-medium tw-text-iron-400 sm:tw-px-6 sm:tw-text-md" onClick={t13} onMouseEnter={t14} onMouseLeave={t15}>{t16}</th>;
    $[35] = t13;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== onSort) {
    t18 = () => onSort(ApiCommunityMembersSortOption.Rep);
    $[38] = onSort;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  let t20;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => setHoverOption(ApiCommunityMembersSortOption.Rep);
    t20 = () => setHoverOption(null);
    $[40] = t19;
    $[41] = t20;
  } else {
    t19 = $[40];
    t20 = $[41];
  }
  let t21;
  if ($[42] !== activeSort || $[43] !== hoverOption || $[44] !== isLoading || $[45] !== sortDirection) {
    t21 = <CommunityMembersTableHeaderSortableContent sort={ApiCommunityMembersSortOption.Rep} activeSort={activeSort} sortDirection={sortDirection} isLoading={isLoading} hoveringOption={hoverOption} />;
    $[42] = activeSort;
    $[43] = hoverOption;
    $[44] = isLoading;
    $[45] = sortDirection;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t18 || $[48] !== t21) {
    t22 = <th scope="col" className="tw-group tw-cursor-pointer tw-whitespace-nowrap tw-px-4 tw-py-3 tw-text-right tw-text-sm tw-font-medium tw-text-iron-400 sm:tw-px-6 sm:tw-text-md" onClick={t18} onMouseEnter={t19} onMouseLeave={t20}>{t21}</th>;
    $[47] = t18;
    $[48] = t21;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== onSort) {
    t23 = () => onSort(ApiCommunityMembersSortOption.Cic);
    $[50] = onSort;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  let t25;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = () => setHoverOption(ApiCommunityMembersSortOption.Cic);
    t25 = () => setHoverOption(null);
    $[52] = t24;
    $[53] = t25;
  } else {
    t24 = $[52];
    t25 = $[53];
  }
  let t26;
  if ($[54] !== activeSort || $[55] !== hoverOption || $[56] !== isLoading || $[57] !== sortDirection) {
    t26 = <CommunityMembersTableHeaderSortableContent sort={ApiCommunityMembersSortOption.Cic} activeSort={activeSort} sortDirection={sortDirection} isLoading={isLoading} hoveringOption={hoverOption} />;
    $[54] = activeSort;
    $[55] = hoverOption;
    $[56] = isLoading;
    $[57] = sortDirection;
    $[58] = t26;
  } else {
    t26 = $[58];
  }
  let t27;
  if ($[59] !== t23 || $[60] !== t26) {
    t27 = <th scope="col" className="tw-group tw-cursor-pointer tw-whitespace-nowrap tw-px-4 tw-py-3 tw-text-right tw-text-sm tw-font-medium tw-text-iron-400 sm:tw-px-6 sm:tw-text-md" onClick={t23} onMouseEnter={t24} onMouseLeave={t25}>{t26}</th>;
    $[59] = t23;
    $[60] = t26;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  let t28;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <th scope="col" className="tw-group tw-whitespace-nowrap tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-text-iron-400 sm:tw-pr-6 sm:tw-text-md"><span>Last Seen</span></th>;
    $[62] = t28;
  } else {
    t28 = $[62];
  }
  let t29;
  if ($[63] !== t12 || $[64] !== t17 || $[65] !== t22 || $[66] !== t27 || $[67] !== t7) {
    t29 = <thead className="tw-border-x-0 tw-border-b tw-border-t-0 tw-border-iron-700 tw-bg-iron-900"><tr>{t1}{t2}{t7}{t12}{t17}{t22}{t27}{t28}</tr></thead>;
    $[63] = t12;
    $[64] = t17;
    $[65] = t22;
    $[66] = t27;
    $[67] = t7;
    $[68] = t29;
  } else {
    t29 = $[68];
  }
  return t29;
}